export const SeoExpertsBlockTexts = {
  ToolTipTitle: 'Мнение эксперта',
  title: 'Информация проверена экспертами',
};

export const getAvatarUrl = (expertId: number) => `https://f.sravni.ru/avatars/${expertId}-s.svg`;
